module.exports = __webpack_public_path__ + "img/abacus_type_4 (old).0a721f8e.png";